<template>
  <div class="max-h-screen bg-gradient-to-br from-blue-50 to-cyan-50 flex items-center justify-center rounded-3xl ">
    <!-- Main Card Container -->
    <div class="w-full max-w-6xl bg-white rounded-3xl shadow-2xl overflow-hidden border border-gray-100">
      <div class="flex flex-col lg:flex-row">
        <!-- Left Panel - Welcome Section -->
        <div class="lg:w-1/2 bg-gradient-to-br from-blue-400 via-blue-500 to-cyan-400 relative overflow-hidden p-16">
          <!-- Background Patterns -->
        
          
          <!-- Content -->
          <div class="relative z-10 flex flex-col justify-center h-full text-white">
            <!-- Logo -->
            <div class="mb-8 flex justify-center">
              <div class="w-24 h-24  flex items-center justify-center mb-4">
                <img src="/images/logo.png" alt="Mascotijo Logo" class="w-32 h-32 object-contain" />
              </div>
            </div>
            
            <!-- Welcome Text -->
            <div class="max-w-md">
              <h1 class="text-5xl font-bold mb-6 leading-tight">
                Hola,<br>
                ¡bienvenido!
              </h1>
            </div>
          </div>
        </div>
        
        <!-- Right Panel - Login Form -->
        <div class="lg:w-1/2 p-16">
          <!-- Mobile Logo -->
          <div class="lg:hidden text-center mb-8">
            <div class="inline-flex w-16 h-16 bg-blue-500 rounded-2xl items-center justify-center mb-4">
              <img src="/images/logo.png" alt="Mascotijo Logo" class="w-10 h-10 object-contain" />
            </div>
            <h1 class="text-2xl font-bold text-gray-900">Mascotijo</h1>
          </div>
          
          <form @submit.prevent="handleLogin" class="space-y-6">
            <!-- Email Field -->
            <div>
              <label for="email" class="block text-sm font-medium text-gray-700 mb-2">
                Correo electrónico
              </label>
              <input
                id="email"
                v-model="form.email"
                type="email"
                required
                class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                :class="{ 'border-red-500 ring-red-500 focus:ring-red-500 focus:border-red-500': errors.email }"
                placeholder="nombre@email.com"
              />
              <p v-if="errors.email" class="text-sm text-red-600 mt-1">{{ errors.email }}</p>
            </div>

            <!-- Password Field -->
            <div>
              <label for="password" class="block text-sm font-medium text-gray-700 mb-2">
                Contraseña
              </label>
              <div class="relative">
                <input
                  id="password"
                  v-model="form.password"
                  :type="showPassword ? 'text' : 'password'"
                  required
                  class="w-full px-4 py-3 pr-12 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                  :class="{ 'border-red-500 ring-red-500 focus:ring-red-500 focus:border-red-500': errors.password }"
                  placeholder="••••••••••••"
                />
                <button
                  type="button"
                  @click="showPassword = !showPassword"
                  class="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600"
                >
                  <svg v-if="showPassword" class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L3 3m6.878 6.878L21 21" />
                  </svg>
                  <svg v-else class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                  </svg>
                </button>
              </div>
              <p v-if="errors.password" class="text-sm text-red-600 mt-1">{{ errors.password }}</p>
            </div>

            <!-- Remember Me and Forgot Password -->
            <div class="flex items-center justify-between">
              <div class="flex items-center">
                <input
                  id="remember"
                  v-model="form.remember"
                  type="checkbox"
                  class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                />
                <label for="remember" class="ml-2 block text-sm text-gray-700">
                  Recordarme
                </label>
              </div>
             
            </div>

            <!-- Submit Button -->
            <button
              type="submit"
              :disabled="authStore.isLoading"
              class="w-full bg-blue-600 text-white py-3 px-4 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors font-medium"
            >
              <span v-if="authStore.isLoading" class="flex items-center justify-center">
                <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Iniciando sesión...
              </span>
              <span v-else>Iniciar sesión</span>
            </button>

            <!-- Error Message -->
            <div v-if="errors.general" class="bg-red-50 border border-red-200 rounded-lg p-4">
              <div class="flex">
                <svg class="h-5 w-5 text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <div class="ml-3">
                  <p class="text-sm text-red-800">{{ errors.general }}</p>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '../stores/auth'

export default {
  name: 'Login',
  setup() {
    const router = useRouter()
    const authStore = useAuthStore()
    
    const showPassword = ref(false)
    
    const form = reactive({
      email: '',
      password: '',
      remember: false
    })
    
    const errors = reactive({
      email: '',
      password: '',
      general: ''
    })

    const validateForm = () => {
      errors.email = ''
      errors.password = ''
      errors.general = ''
      
      let isValid = true
      
      if (!form.email) {
        errors.email = 'El correo electrónico es requerido'
        isValid = false
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
        errors.email = 'El correo electrónico no es válido'
        isValid = false
      }
      
      if (!form.password) {
        errors.password = 'La contraseña es requerida'
        isValid = false
      } else if (form.password.length < 6) {
        errors.password = 'La contraseña debe tener al menos 6 caracteres'
        isValid = false
      }
      
      return isValid
    }

    const handleLogin = async () => {
      if (!validateForm()) return
      
      try {
        const result = await authStore.login({
          email: form.email,
          password: form.password
        })
        
        if (result.success) {
          router.push('/')
        }
      } catch (error) {
        errors.general = error.message || 'Error al iniciar sesión. Verifica tus credenciales.'
      }
    }

    return {
      authStore,
      form,
      errors,
      showPassword,
      handleLogin
    }
  }
}
</script>